import * as React from 'react';
import { Component } from 'react';
import intl from 'react-intl-universal';
import { Button, Modal, Radio, Input, Table } from 'antd';
import _cloneDeep from 'lodash/cloneDeep';
import _pick from 'lodash/pick';
import cuid from 'cuid';
import './index.scss';

export default class Internet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ctrl: false,
      shift: false,
      visible: false,
      type: 'custom',
      inputUrl: '',
      siteRight: 'always',
      siteList: [],
      selectedRowKeys: [],
    };
  }

  componentDidMount() {
    const setting = JSON.parse(localStorage.getItem('TRUST_SITE_SET'));
    setting &&
      this.setState({
        ...setting,
      });

    const that = this;
    document.onkeydown = (e) => {
      if (e.keyCode === 17) {
        that.setState({
          ctrl: true,
        });
      } else {
        if (e.keyCode === 16) {
          that.setState({
            shift: true,
          });
        }
      }
    };

    document.onkeyup = () => {
      that.setState({
        shift: false,
        ctrl: false,
      });
    };
  }

  handleClose = () => {
    this.setState({
      visible: false,
    });
  };

  openDialog = () => {
    this.setState({
      visible: true,
    });
  };

  radioInputChange = (k, v) => {
    this.setState({
      [k]: v,
    });
  };

  addToList = (right) => {
    const rightText = 'Always ' + right;
    const url = this.state.inputUrl;
    const arr = url.split('.');
    if (arr.length < 3) {
      return;
    }
    if (arr[1].length < 2) {
      return;
    }
    const dataUpdate = _cloneDeep(this.state.siteList);
    const hasItem = dataUpdate.find((item) => item.url === url);
    if (hasItem) {
      window.pdfui.eventEmitter.emit('existInternetUrl');
      return;
    }
    dataUpdate.push({
      url,
      key: cuid(),
      access: rightText,
    });
    this.setState({
      siteList: dataUpdate,
      inputUrl: '',
    });
  };

  selectRowHandle = (clickKey) => {
    const { ctrl, shift } = this.state;
    if (ctrl && shift) {
      return;
    }

    if (!ctrl && !shift) {
      this.setState({
        selectedRowKeys: [clickKey],
      });
    }

    if (ctrl) {
      let { selectedRowKeys } = this.state;
      if (selectedRowKeys.includes(clickKey)) {
        selectedRowKeys = selectedRowKeys.filter((item) => item !== clickKey);
      } else {
        selectedRowKeys.push(clickKey);
      }
      this.setState({ selectedRowKeys });
    }

    if (shift) {
      let { selectedRowKeys, siteList } = this.state;
      if (!selectedRowKeys.length) {
        selectedRowKeys.push(clickKey);
      } else {
        const len = selectedRowKeys.length;
        const startKey = selectedRowKeys[len - 1];
        const endKey = clickKey;
        const startIndex = siteList.findIndex((item) => item.key === startKey);
        const endIndex = siteList.findIndex((item) => item.key === endKey);
        const updateRowArr = [];
        siteList.forEach((item, index) => {
          if ((startIndex <= index && index <= endIndex) || (endIndex <= index && index <= startIndex)) {
            updateRowArr.push(item.key);
          }
        });
        selectedRowKeys = updateRowArr;
      }
      this.setState({ selectedRowKeys });
    }
  };

  deleteSel = () => {
    const { selectedRowKeys } = this.state;
    const dataUpdate = this.state.siteList.filter((item) => !selectedRowKeys.includes(item.key));
    this.setState({
      siteList: dataUpdate,
    });
  };

  handleOk = () => {
    const setting = _pick(this.state, ['type', 'siteRight', 'siteList']);
    window.pdfui.eventEmitter.emit('setTrustSiteEvt', setting);
    this.handleClose();
  };

  render() {
    const Title = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Title' });
    const Des = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Describe' });
    const Btn = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Btn' });
    const DTitle = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Title' });
    const DInfo = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Info' });
    const RCustom = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Type.Custom' });
    const RAllow = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Type.Allow' });
    const RBlock = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Type.Block' });

    const STitle = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Specify.Title' });
    const SSubTitle = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Specify.SubTitle' });
    const SAllow = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Specify.Allow' });
    const SBlock = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Specify.Block' });

    const WTitle = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Site.Title' });
    const WDelete = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Site.Delete' });
    const WName = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Site.Name' });
    const WAccess = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Site.Access' });
    const WTip = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Site.Tip' });
    const WAlways = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Site.Always' });
    const WAllow = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Site.Allow' });
    const WBlock = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Setting.Site.Block' });

    const DOk = intl.formatMessage({ id: 'Preferences.Content.TrustManager.Ok' });
    const DCancel = intl.formatMessage({ id: 'Preferences.Content.TrustManager.Cancel' });

    const columns = [
      {
        title: WName,
        key: 'url',
        render: (text, record) => {
          const { url } = record;
          const arr = url.split('.');
          let urlShow = '';
          if (arr[0].startsWith('//') || arr[0].startsWith('\\')) {
            urlShow = `http://${url}`;
          } else if (!arr[0].startsWith('http://') && !arr[0].startsWith('https://') && !arr[0].startsWith('www') && !arr[0].startsWith('ww')) {
            urlShow = url;
          } else {
            arr.shift();
            urlShow = arr.join('.');
          }
          if (record.access.endsWith('Block')) {
            return <span style={{ color: '#ff4d4f' }}>{urlShow}</span>;
          }
          return <span>{urlShow}</span>;
        },
      },
      {
        title: WAccess,
        key: 'access',
        render: (text, record) => {
          if (record.access.endsWith('Block')) {
            return <span style={{ color: '#ff4d4f' }}>{WBlock}</span>;
          }
          return <span>{WAllow}</span>;
        },
      },
    ];

    return (
      <>
        <div className="title">{Title}</div>
        <div className="LayoutGrid board tr-btn">
          <p>{Des}</p>
          <Button size="small" className="change-setting-btn" onClick={this.openDialog}>
            {Btn}
          </Button>
        </div>
        <Modal
          className="internet-dialog"
          maskClosable={false}
          title={DTitle}
          visible={this.state.visible}
          cancelText={DCancel}
          okText={DOk}
          onOk={this.handleOk}
          onCancel={this.handleClose}
          centered={true}>
          <div className="body-box">
            <p>{DInfo}</p>
            <div className="radio-box">
              <Radio.Group value={this.state.type} onChange={(e) => this.radioInputChange('type', e.target.value)}>
                <Radio value="custom">{RCustom}</Radio>
                <Radio value="allow">{RAllow}</Radio>
                <Radio value="block">{RBlock}</Radio>
              </Radio.Group>
            </div>
            <div className="title">{STitle}</div>
            <div className="LayoutGrid board">
              <p>{SSubTitle}</p>
              <Input
                disabled={this.state.type !== 'custom'}
                value={this.state.inputUrl}
                onChange={(e) => this.radioInputChange('inputUrl', e.target.value)}></Input>
              <div className="btn-box">
                <Button size="small" disabled={this.state.type !== 'custom' || !this.state.inputUrl} onClick={() => this.addToList('Allow')}>
                  {SAllow}
                </Button>
                <Button size="small" disabled={this.state.type !== 'custom' || !this.state.inputUrl} onClick={() => this.addToList('Block')}>
                  {SBlock}
                </Button>
              </div>
            </div>
            <div className="title">{WTitle}</div>
            <Button className="style-btn" size="small" disabled={this.state.type !== 'custom' || !this.state.siteList.length} onClick={() => this.deleteSel()}>
              {WDelete}
            </Button>
            <div className="LayoutGrid board table-box">
              <Table
                onRow={(record) => {
                  return {
                    onClick: () => this.selectRowHandle(record.key),
                  };
                }}
                className="list-table"
                rowClassName={(record) => {
                  return this.state.selectedRowKeys.includes(record.key) ? 'rowHightLight' : '';
                }}
                size="small"
                pagination={false}
                scroll={{ y: 140 }}
                columns={columns}
                dataSource={this.state.siteList}
              />
              <p className="mtb">{WTip}</p>
              <div className="radio-box">
                <Radio.Group
                  value={this.state.siteRight}
                  disabled={this.state.type !== 'custom'}
                  onChange={(e) => this.radioInputChange('siteRight', e.target.value)}>
                  <Radio value="always">{WAlways}</Radio>
                  <Radio value="allow">{WAllow}</Radio>
                  <Radio value="block">{WBlock}</Radio>
                </Radio.Group>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
